<template>
    <div class="panel-body">
     <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
         <TableGeneral :optionst="options" :optionss="optionss" :fields="fields" :requiereListas="requiereListas" 
         :requiereDescarga="requiereDescarga" :condicionFiltrao="condicionFiltrao" :cliente="cliente" :editar="editable"
         :opcionRetirar="opcionRetirar" :condicionales="condicionales" :carpeta="carpeta" :datosExcel="datosExcel" :typeOrder="typeOrder" ></TableGeneral>
     </div>
    
 </template>
 
 <script>
 import { RepositoryFactory } from "../../repositories/RepositoryFactory";
 import Vue from 'vue'
 import VueFormGenerator from 'vue-form-generator'
 import 'vue-form-generator/dist/vfg.css'
 import TableGeneral from "../../components/Table.vue";
 import HeaderGeneral from "../../components/HeaderGeneral.vue";
 import "vue-form-generator/dist/vfg-core.css";
 
 
 Vue.use(VueFormGenerator)
 
 const config = RepositoryFactory.get("config");
 const clientes = RepositoryFactory.get("clientes");
 export default {
     components: {
         "vue-form-generator": VueFormGenerator.component,
         TableGeneral,
         HeaderGeneral
     },
     data() {
         return {
            typeOrder: "desc",
            datosExcel:[],
            nombreEntidad: "entidad_solicitud",
            idVersion: 2,
            column: "id",
            perPage: 100,
            currentPage: 1,
             vista:"Histórico de proveedor",
             proveniente:" - Histórico de proveedor",
             carpeta:"Prestadores",
             requiereListas:true,
             requiereDescarga:true,
             condicionFiltrao:"no",
             editable:1,
             cliente:1,
             opcionRetirar:false,
             options: [{ value: null, text: 'Seleccionar' }, { value: 'id', text: 'Número de solicitud' }, { value: 'documento', text: 'Documento' }, { value: 'nombre_completo', text: 'Paciente' }, { value: 'estado', text: 'Estado' }],
             optionss: [
             { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                  { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '5', text: 'Solicitud retiro' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '11', text: 'Cancelado' },

            ],
            fields: [{ key: 'N° solicitud', sortable: true },
             { key: 'Proveedor', sortable: true }, 
              { key: 'Cliente', sortable: true }, 
               { key: 'Paciente', sortable: true }, 
               { key: 'Estado', sortable: true },
               { key: 'Departamento', sortable: true },
               { key: 'Ciudad', sortable: true },
               { key: 'F.Entrega elementos', sortable: true },
                { key: 'F.Retiro elementos', sortable: true }, 'Acciones'],  
            condicionales: {
                "AND": [
                    {
                        "estado": {
                            "notEquals": ""
                        }
                    },


                ]
            }, 
            relaciones: [
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "tipo_documento",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 6,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "Tipos_documento"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "medio_administracion",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 6,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "motivos_rechazo_proveedor"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "codigo_departamento" },
                        "columna_relacion_principal": "departamento",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 50,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "divipola_colombia"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "listados",
                        "columna_relacion": { "rows": "id" },
                        "columna_relacion_principal": "estado",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "nombre_lista": {
                                            "iLike": "estados"
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_proveedor",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_proveedor",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_cliente",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_cliente",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                },
                {
                    "entidad": {
                        "nombre": "entidad_prestador",
                        "columna_relacion": "id",
                        "columna_relacion_principal": "id_prestador",
                        "order": {
                            "column": "col",
                            "type": "asc"
                        },
                        "size": 5,
                        "page": 1,
                        "where": [
                            {
                                "AND": [
                                    {
                                        "id": {
                                            "iLike": ""
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }
            ],
         }
 
     },
     computed: {
       
     },
     async created() {
        try {
            var where = [this.condicionales];
            var params = {
                        "nombreEntidad": this.nombreEntidad,
                        "idVersion": this.idVersion,
                        "column": this.column,
                        "type": this.typeOrder,
                        "size": this.perPage,
                        "page": this.currentPage,
                    }
                    const response = await config.getMetaData(params, where, this.relaciones);
                    
                    this.totalfilas = response.message.count
                    this.items = [];
                    var cantidad = this.perPage;
                   
                    if(response.message =='Error no se encontró datos'){
                        this.totalfilas=0;
                    }

                    var dataexcel=[]
                    for (var i = 0; i < cantidad; i++) {
                        var estadosE = response.message.rows;
                        var numeracion = ((this.currentPage - 1) * cantidad) + i;
                        var dataTable = estadosE[i]['data'];


                        
                        const objetoBuscado = dataTable.listados.flat().find(item => item.row_data && item.row_data.id === dataTable.tipo_documento && item.nombre_lista === "Tipos_documento");
                        const nameResultado = objetoBuscado ? objetoBuscado.row_data.name : null;
                        const estadobuscando = dataTable.listados.flat().find(item => item.row_data && item.row_data.id === dataTable.estado && item.nombre_lista === "estados");
                        const estadoresultado = estadobuscando ? estadobuscando.row_data.name : null;

                       
                        const nombreCliente = dataTable.entidad_cliente[0][0]?.data?.nombre_cliente || "";
                        const nombreProveedor = dataTable.entidad_proveedor[0][0]?.data?.nombre_proveedor || "";
                        const nombrePrestador = dataTable.entidad_prestador[0][0]?.data?.nombre_prestador || "";
                        const departamentobuscado = dataTable.listados.flat().find(item => item.row_data && item.row_data.codigo_departamento === dataTable.departamento && item.nombre_lista === "divipola_colombia");
                        const departamentoResultado = departamentobuscado ? departamentobuscado.row_data.nombre_departamento : null;
                        const municipiobuscando =dataTable.listados.flat().find(item => item.row_data && item.row_data.codigo_municipio === dataTable.municipio && item.nombre_lista === "divipola_colombia")
                        const municipioResultado = municipiobuscando ? municipiobuscando.row_data.nombre_municipio : null;
                      
                        this.datosExcel[numeracion] = {
                            'N°Solicitud': dataTable.id,
                            'Proveedor': nombreProveedor,
                            'Cliente': nombreCliente,
                            "Paciente": dataTable.nombre_completo,
                            "Estado": estadoresultado,
                            'Departamento': departamentoResultado,
                            'Ciudad': municipioResultado,
                            'F.Entrega elementos': dataTable.fecha_entrega_elementos ? dataTable.fecha_entrega_elementos.slice(0, 10) : '',
                            'F.Retiro elementos': dataTable.fecha_retiro_oxigeno ? dataTable.fecha_retiro_oxigeno.slice(0, 10) : '',
                        };
                    }  
            } catch (error) {
                console.log(error)
            }
        
     },
     methods: {
       
     }
 };
 </script>
 <style>
 </style>

